import React from 'react';
import * as ds from './dataService';
import { FormBaseLayout } from 'modules/components/layer10';
import { StyledTextField } from 'modules/components/layer01';
import { Stack } from '@mui/material';

export type SaveClientReportLinkFormProps = {
  id: string;
  clientReportId: string;
  handleClose: () => void;
};

export const FC = (props: SaveClientReportLinkFormProps) => {
  const [
    fnSaveClientReportLinkForm,
    { loading }
  ] = ds.useSaveClientReportLink();
  const form = ds.useFormState(props.id, props.clientReportId);
  const handleSubmit = async (input: typeof form.formState) => {

    await fnSaveClientReportLinkForm(input);
    props.handleClose();
  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={() => {
        handleSubmit(form.formState);
      }}
      cancelButtonText='Cancel'
      successButtonText='Save'
      isLoading={loading}
    >
      <Stack
        direction='column'
        rowGap='1.5rem'
      >
        <StyledTextField.FC
          {...form.genFieldProps('url')}
        />
        <StyledTextField.FC
          {...form.genFieldProps('notesForClient')}
        />
      </Stack>
    </FormBaseLayout.FC>

  );
};
